(<template>
  <section class="credentials">
    <div class="credentials__wrapper">
      <sk-note :text="credentialsInfoText"
               class="credentials__note" />
      <div v-for="field in fields"
           :key="field.name"
           class="credentials__item"
           :class="{ 'credentials__item--offset': field.name === 'username' }">
        <div>
          <p class="credentials__item-subtitle">{{ $gettext(field.label) }}</p>
          <p class="credentials__item-value">
            {{ !showValue ? '********' : credentials[field.name] }}
          </p>
        </div>
        <copy-button @clicked="requestPassword(field.name)" />
      </div>
    </div>
  </section>
</template>)

<script>
  import CopyButton from '@/components/shared_components/CopyButton';

  export default {
    components: {
      'copy-button': CopyButton
    },
    props: {
      credentials: {
        type: Object,
        default: () => {}
      },
      subtaskId: {
        type: String,
        default: ''
      },
      orderId: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        showValue: false,
        dataRequested: false
      };
    },
    computed: {
      credentialsInfoText() { return this.$gettext('Use these credentials to log in to MemoQ before accessing the project.'); },
      fields() {
        return [
          {name: 'username', label: this.$gettext('Username')},
          {name: 'password', label: this.$gettext('Password')},
        ];
      }
    },
    methods: {
      copyToClipboard(field) {
        navigator.clipboard.writeText(this.credentials[field]).then(() => { this.showValue = true; });
      },
      requestPassword(field) {
        if (this.dataRequested) {
          this.copyToClipboard(field);
        } else {
          this.$store.dispatch('OneProjectStore/requestMemoQ', {order_id: this.orderId, subtask_id: this.subtaskId}).then(() => {
            this.dataRequested = true;
            this.copyToClipboard(field);
          });
        }
      },
    },
  };
</script>

<style scoped>
.credentials__wrapper {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding: 0 0 8px 0;
  border-radius: 4px;
  background-color: var(--color-warning-200, #fff4db);
}

.credentials__note {
  width: 100%;
}

.credentials__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: calc(50% - 20px);
  margin-top: 4px;
  padding: 8px 12px;
  border-radius: 8px;
  background-color: var(--color-white);
  font-size: 12px;
}

.credentials__item--offset {
  margin: 4px 8px 0 25px;
}

.credentials__item-subtitle {
  color: var(--black-500);
}

.credentials__item-value {
  color: var(--black-700);
  font-weight: 700;
}
</style>
